export default {"src":"/_next/static/image/public/images/flags/flag_260.b38db47fb110e9fac89a592af18caf31.svg","height":16,"width":24};